// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreements-dropdown[data-v-46d7fa40] .buttons-wrapper{width:100%}.agreements-dropdown .agreements-toggle[data-v-46d7fa40]{width:280px !important}@media(max-width: 1199.98px){.agreements-dropdown .agreements-toggle[data-v-46d7fa40]{width:290px}}", ""]);
// Exports
module.exports = exports;
